import React, { useEffect, useState } from 'react';
import { axiosWrapper } from '../../../../../hooks/axios';
import Plugin, { PluginProps } from '../Plugin';

const ConditionalBlock = (props: PluginProps) => {
  const { content } = props;
  const [showBlock, setShowBlock] = useState(false);
  const contentData = content.data;

  useEffect(() => {
    axiosWrapper(contentData.url, 'get').then((response) => {
      if (response?.data?.ok) {
        setShowBlock(true);
      }
    });
  }, []);

  if (!showBlock) {
    return null;
  }

  return (
    <>
      {content.children.map((child, index) => {
        return <Plugin key={index} {...props} content={child} />;
      })}
    </>
  );
};

export default ConditionalBlock;
